import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addMenuID } from '~/store/modules/Menu/actions';
import { Container } from '~/styles/pagesStyle';
import { handleDeleteMenu, handleUpdateMenu } from '../MenuServices';
import Card from './Card';

const initialForm = {
  idModulo: '',
  idSituacaoCadastral: '',
  nome: '',
  descricao: '',
  nomeImagem: '',
  ordem: '',
  url: '',
  tipoPagina: '',
};

function MenuUpdate() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [menuData, setMenuData] = useState({});
  const [form, setForm] = useState(initialForm);
  const usuarioLogado = sessionStorage.getItem('@auth/userName');

  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addMenuID(id));
      await api
        .get(`Menu/${id}`)
        .then((response) => {
          setMenuData(response.data);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados do menu, tente novamente');
          history.goBack();
        });
    }
    getData();
  }, []);

  async function handleUpdate(e) {
    e.preventDefault();
    setLoading(true);
    const menu = {
      id,
      idModulo: menuData.idModulo,
      idSituacaoCadastral:
        form.idSituacaoCadastral || menuData.idSituacaoCadastral,
      nome: form.nome || menuData.nome,
      descricao: form.descricao || menuData.descricao,
      nomeImagem: form.nomeImagem === '' ? null : form.nomeImagem,
      ordem: form.ordem || menuData.ordem,
      url: form.tipoPagina === 'O' ? form.url : null,
      tipoPagina: form.tipoPagina || menuData.tipoPagina,
      dataInclusao: null,
      usuario: usuarioLogado,
      excluido: true,
    };
    await handleUpdateMenu(menu, setLoading);
    history.push('/menu/list');
  }

  async function handleDelete() {
    await handleDeleteMenu(setLoading);
    history.push('/menu/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(menuData).lenght === 0 ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', marginTop: '100px' }}
          color="dark"
        />
      ) : (
        <Card
          loading={loading}
          setForm={setForm}
          form={form}
          menuData={menuData}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
        />
      )}
    </Container>
  );
}

export default MenuUpdate;
